import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the benign Chromium warning fired during ResizeObserver
// chains — it is a well-known false-positive surfaced by
// react-error-overlay in dev mode. We install with capture=true so we
// intercept before react-error-overlay's listener. This is purely cosmetic
// and does not mask real errors.
const RO_MESSAGES = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);
const handleResizeObserverError = (event) => {
  const msg = event?.message || "";
  if (RO_MESSAGES.has(msg)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
};
window.addEventListener("error", handleResizeObserverError, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
